import { Box, Stack, Typography } from '@mui/material'
import LogoDashboard from '../LogoDashboard'
import classes from './styles.module.scss'
import ScreenRotationIcon from '@mui/icons-material/ScreenRotation'

const OrientationWarning = () => {
  return (
    <Stack className={classes.root}>
      <Box className={classes.container}>
        <Box sx={{ scale: '2.2' }}>
          <LogoDashboard />
        </Box>
        <Box className={classes.boxContent}>
          <ScreenRotationIcon style={{ width: 48, height: 48, color: '#fff' }} />
          <Typography className={classes.title}>Please Rotate Your Device</Typography>
          <Typography className={classes.txtContent}>
            This application is designed to be used in landscape mode.
          </Typography>
          <Typography className={classes.txtContent}>
            Please rotate your device to continue.
          </Typography>
        </Box>
      </Box>
    </Stack>
  )
}

export default OrientationWarning
